import styled from "styled-components";
import { Input } from "antd";
import { AiOutlineSearch } from "react-icons/ai";
import { isMobile } from "react-device-detect";

export const SearchPopupWrapper = styled.div`
  position: fixed;
  left: ${isMobile ? "55px" : "62px"};
  top: 48px;
  max-width: ${isMobile ? "calc(100vw - 55px)" : "calc(100vw - 62px)"};
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  max-height: 304px;
  background-color: #fafafa;
  overflow: hidden;
`;

export const SearchInputWrapper = styled.div`
  padding: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  .close-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
    background: transparent;
    cursor: pointer;
    color: #000000d9;
    font-size: 18px;
    transition: color 0.2s ease, transform 0.2s ease, background-color 0.2s ease;
    &:hover {
      color: #1e90ff;
      background-color: rgba(30, 144, 255, 0.08);
      transform: scale(1.05);
    }
    &:active {
      transform: scale(0.95);
      color: #0f6ad1;
      background-color: rgba(30, 144, 255, 0.12);
    }
  }
`;

export const CompanyList = styled.div`
  padding: 12px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  flex: 1;
  overflow-y: auto;
  margin-bottom: 8px;
  max-height: calc(100vh - 120px);
  position: relative;
  border-radius: 6px;

  /* Scrollbar styles */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const LoadingOverlayWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  > div {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-spin-dot {
    font-size: 28px;
  }

  .ant-spin-dot-item {
    background-color: #0b2d9c;
  }
`;

export const SearchIcon = styled(AiOutlineSearch as any)`
  color: rgba(0, 0, 0, 0.45);
  font-size: 18px;
`;

export const StyledInput = styled(Input as any)`
  border-radius: 4px;

  .ant-input {
    padding-right: 8px;
    font-size: ${isMobile ? "16px" : "inherit"};
  }

  .ant-input-suffix {
    margin-left: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const CompanyItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 4px;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const CompanyLogoWrapper = styled.div`
  height: 36px;
  width: 36px;
  min-width: 36px;
  border-radius: 50%;
  border: 1px solid #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  flex-shrink: 0;
`;

export const CompanyLogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #f0f0f0;
`;

export const CompanyLogoText = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #dddfe6;
  font-size: 14px;
  font-weight: 500;
  border-radius: 50%;
`;

export const CompanyName = styled.span`
  font-size: 14px;
  color: #000000d9;
`;

export const EmptyState = styled.div`
  padding: 24px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;
